export default __webpack_public_path__ + "static/media/4.07260c45.jpg";